import React from "react";
import AdminSlidesComponent from "./adminSlidesComponent";

const AdminSlides = ({ bookId, pageId, book, hasPermission = true }) => {
  return <AdminSlidesComponent bookId={bookId} pageId={pageId} book={book} hasPermission={hasPermission} />;
};

export default AdminSlides;
